import { apiFetch } from '~/utils/apiFetch'

import type {
  ClaimAllTaskResponseDto,
  ClaimRakebackRequestDto,
  ClaimRakebackResultDto,
  PeriodicClaimRequestDto,
  PeriodicClaimResultDto,
  RakebackPanelDto,
  UnifiedClaimModule,
  UnifiedClaimPageDto,
  UnifiedClaimTimeRange,
  RakebackRatesDto,
  TaskClaimResultDto,
  TaskPanelDto,
  UpgradeClaimResponseDto,
  VipSalaryPanelDto,
  PromoListDto,
  PromoActivityDto,
  PromoClaimResultDto,
  RewardSectionListsDto,
  RewardOverviewDto,
} from '~/types/api/promo'

/** GET /api/v1/rewards/vip-salary — VIP 俸禄面板 */

export function fetchVipSalaryPanel() {
  return apiFetch<VipSalaryPanelDto>('/rewards/vip-salary')
}

/** GET /api/v1/rewards/tasks — 奖励任务面板 */

export function fetchTaskPanel() {
  return apiFetch<TaskPanelDto>('/rewards/tasks', {
    method: 'GET',
  })
}

/** POST /api/v1/rewards/tasks/claim-all — 一键领取任务阶段 */

export function claimAllTasks() {
  return apiFetch<ClaimAllTaskResponseDto>('/rewards/tasks/claim-all', {
    method: 'POST',

    body: {},
  })
}

/** POST /api/v1/rewards/tasks/{task_code}/stages/{stage_no}/claim — 领取任务阶段 */

export function claimTaskStage({ taskCode, stageNo }: { taskCode: string; stageNo: number }) {
  return apiFetch<TaskClaimResultDto>(`/rewards/tasks/${taskCode}/stages/${stageNo}/claim`, {
    method: 'POST',

    body: {},
  })
}

/** POST /api/v1/rewards/vip-salary/claim — 领取当前有效周期的日/周/月俸禄 */

export function claimPeriodicSalary(payload: PeriodicClaimRequestDto) {
  return apiFetch<PeriodicClaimResultDto>('/rewards/vip-salary/claim', {
    method: 'POST',

    body: { cycle_no: payload.cycleNo, cycle_type: payload.cycleType },
  })
}

/** POST /api/v1/rewards/vip-salary/upgrades/claim-all — 批量领取当前全部可用的晋级彩金 */

export function claimUpgradeBonus() {
  return apiFetch<UpgradeClaimResponseDto>('/rewards/vip-salary/upgrades/claim-all', {
    method: 'POST',

    body: {},
  })
}

/** GET /api/v1/rewards/rakeback/panel — 返水面板 */

export function fetchRakebackPanel() {
  return apiFetch<RakebackPanelDto>('/rewards/rakeback/panel', {
    method: 'GET',
  })
}

/** POST /api/v1/rewards/rakeback/claim — 领取返水 */

export function claimRakeback(payload: ClaimRakebackRequestDto) {
  return apiFetch<ClaimRakebackResultDto>('/rewards/rakeback/claim', {
    method: 'POST',

    body: payload,
  })
}

/** GET /api/v1/rewards/rakeback/rates — 返水比例详情 */

export function fetchRakebackRates(params: { game_type?: string; vendor_code?: string }) {
  return apiFetch<RakebackRatesDto>('/rewards/rakeback/rates', {
    method: 'GET',

    params,
  })
}

/**
 * GET /api/v1/rewards/claims — 合并领取记录（游标翻页）
 * 时间窗口传 time_range（服务端按站点时区切日，左闭右开）；与 from_time/to_time 互斥，同时传 400。
 */

export function fetchUnifiedClaims(params: {
  cursor?: string

  page_size?: number

  module?: UnifiedClaimModule

  time_range?: UnifiedClaimTimeRange
}) {
  return apiFetch<UnifiedClaimPageDto>('/rewards/claims', {
    method: 'GET',

    params,
  })
}

/** GET /api/v1/rewards/promotions — 优惠活动列表（分类导航 + 活动卡） */

export function fetchPromotions(params: {
  category?: string

  keyword?: string

  page?: number

  page_size?: number
}) {
  return apiFetch<PromoListDto>('/rewards/promotions', {
    method: 'GET',

    params,
  })
}

/** GET /api/v1/rewards/promotions/{activity_code} — 活动详情（多 detail 图） */

export function fetchPromotionDetail(activityCode: string) {
  return apiFetch<PromoActivityDto>(`/rewards/promotions/${activityCode}`, {
    method: 'GET',
  })
}

/** POST /api/v1/rewards/promotions/{activity_code}/claim — 领取活动奖励 */

export function claimPromotion(activityCode: string, cycleNo: string) {
  return apiFetch<PromoClaimResultDto>(`/rewards/promotions/${activityCode}/claim`, {
    method: 'POST',

    body: { cycle_no: cycleNo },
  })
}

/** PUT /api/v1/rewards/promotions/birthday — 设置生日（仅一次，不可改） */

export function setPromotionBirthday(birthday: string) {
  return apiFetch<unknown>('/rewards/promotions/birthday', {
    method: 'PUT',

    body: { birthday },
  })
}

/** GET /api/v1/rewards/section-lists — 奖励栏目清单（导航页签 + 领取记录筛选） */

export function fetchRewardSectionLists() {
  return apiFetch<RewardSectionListsDto>('/rewards/section-lists', {
    method: 'GET',
  })
}

/** GET /api/v1/rewards/overview — 奖励中心总览（五模块可领角标） */

export function fetchRewardOverview() {
  return apiFetch<RewardOverviewDto>('/rewards/overview', {
    method: 'GET',
  })
}
